import { IMAGE_BASE_PATH, IMAGE_FORMATS, IMAGE_WIDTHS } from '../../../core/constants/images';

import './styles/ResponsiveImage.css';

function buildSrcSet(name, widths, format) {
    return widths.map(width => `${IMAGE_BASE_PATH}/${name}-${width}.${format} ${width}w`).join(', ');
}

export default function ResponsiveImage({
    name,
    alt,
    sizes,
    width,
    height,
    widths = IMAGE_WIDTHS.DEFAULT,
    isPriority = false,
    className = '',
}) {
    const fallbackWidth = widths[Math.min(1, widths.length - 1)];

    return (
        <picture className="responsive-image">
            {IMAGE_FORMATS.map(format => (
                <source key={format} type={`image/${format}`} srcSet={buildSrcSet(name, widths, format)} sizes={sizes} />
            ))}
            <img
                className={className}
                src={`${IMAGE_BASE_PATH}/${name}-${fallbackWidth}.webp`}
                alt={alt}
                width={width}
                height={height}
                loading={isPriority ? 'eager' : 'lazy'}
                fetchPriority={isPriority ? 'high' : 'auto'}
                decoding="async"
            />
        </picture>
    );
}
